import { QUERY_DELETE_SUPPLIER, QUERY_GET_SUPPLIERS, QUERY_GET_SUPPLIERSPAG, QUERY_POST_CREATE_SUPPLIER, QUERY_PUT_EDIT_SUPPLIER, QUERY_PUT_TOGGLE_ACTIVE_SUPPLIER } from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getSuppliers = baseThunk(`suppliers/getSuppliers`, QUERY_GET_SUPPLIERS, "GET");
export const getSuppliersPag = baseThunk(`suppliers/getSuppliersPag`, QUERY_GET_SUPPLIERSPAG, "GET");

export const createSupplier = baseThunk("suppliers/create", QUERY_POST_CREATE_SUPPLIER, "POST");
export const deleteSupplier = baseThunk("suppliers/delete", QUERY_DELETE_SUPPLIER, "DELETE");
export const editSupplier = baseThunk("suppliers/update", QUERY_PUT_EDIT_SUPPLIER, "PUT");
export const toggleActiveSupplier = baseThunk("suppliers/toggleActive", QUERY_PUT_TOGGLE_ACTIVE_SUPPLIER, "PUT");
